import React from "react";
import copyright from "../config/copyright.json";
import { getLocalStorageData } from "../config/helpers";

function HeaderTicket() {
  let localData = getLocalStorageData();
  let isHelp = localData.kaba_info.help;
  let isSignin = localData.kaba_info.login.signin;

  return (
    <div className="title">
      <h3>{copyright.ticket.titre}</h3>
      {isHelp && isSignin ? (
        <p>Merci de donner un numéro sur lequel nous pouvons te contacter </p>
      ) : (
        <p>
          Pour nous aider à résoudre ton problème plus rapidement, donne-nous
          une description détaillée, ainsi qu'une capture d'écran si possible.{" "}
        </p>
      )}
    </div>
  );
}

export default HeaderTicket;
